import { render, staticRenderFns } from "./PaymentEventsPage.vue?vue&type=template&id=609f9684&"
import script from "./PaymentEventsPage.vue?vue&type=script&lang=js&"
export * from "./PaymentEventsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports